import {styled} from "@mui/material/styles";
import {TabPanel} from "@mui/lab";
import {Grid} from "@mui/material";

export const BuyerInventoryFilterContainer = styled(Grid)(() => ({
    width: '100%',
    flexDirection: 'row',
    marginBottom: '1.5em'
}));

export const BuyerInventoryTabPanel = styled(TabPanel)(() => ({
    width: '100%',
    paddingLeft: '0',
    paddingRight: '0',
}));
